import { REMOVE_FILTER, SET_AGE, SET_FILTER, SET_PARTICLES_SIZE } from "./constants"

export const setParticlesSize = (size) => ({
  type: SET_PARTICLES_SIZE,
  size
})

export const setFilter = (key, value, unique) => ({
  type: SET_FILTER,
  key, 
  value,
  unique
})

export const setAge = (value) => ({
  type: SET_AGE,
  value
})

export const removeFilter = (key, value) => ({
  type: REMOVE_FILTER,
  key,
  value
})